import { defineMessages } from 'react-intl';

export const showAllReviewsCallToActionMessages = defineMessages({
  buttonText: {
    defaultMessage: 'Alle Bewertungen ({reviewCount}) anzeigen',
    id: 'customerReviews.showAllReviewsCallToAction.buttonText',
  },
});
